module.exports = __webpack_public_path__ + "static/coming-soon-a190811584a4f63e873660164b072eea.svg";